import React from 'react';
import { Button } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';

interface PreviewPdfButtonProps {
  fileName: string | null | undefined;
  typeUrl: string;
  onOpenPdf: ((url: string, typeUrl: string) => void) | undefined | null;
  label?: string;
  fullWidth?: boolean;
}

export const PreviewPdfButton: React.FC<PreviewPdfButtonProps> = ({
  fileName,
  typeUrl,
  onOpenPdf,
  label = 'Previsualizar Documento',
  fullWidth = true,
}) => {
  if (!fileName || !onOpenPdf) return null;

  return (
    <Button
      startIcon={<VisibilityIcon />}
      size="small"
      variant="outlined"
      color="primary"
      fullWidth={fullWidth}
      sx={{ mt: 1, textTransform: 'none', fontWeight: 'bold' }}
      onClick={() => onOpenPdf(fileName, typeUrl)}
    >
      {label}
    </Button>
  );
};
